/**
 * Normalise une URL pour extraire le chemin relatif
 * Si l'URL est complète (avec domaine), extrait seulement le chemin
 * Si l'URL est déjà relative, la retourne telle quelle
 *
 * @param {string} url - L'URL à normaliser
 * @returns {string} - Le chemin relatif normalisé
 */
export const normalizeUrl = (url) => {
  if (!url) return "/";

  try {
    // Si l'URL contient un protocole (http:// ou https://), c'est une URL complète
    if (url.startsWith("http://") || url.startsWith("https://")) {
      const urlObj = new URL(url);
      return urlObj.pathname;
    }

    // Sinon, c'est déjà un chemin relatif
    return url;
  } catch (e) {
    // En cas d'erreur, retourner l'URL telle quelle ou "/"
    return url || "/";
  }
};
